// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_HAZARDS_SUCCESS,
  GET_HAZARDS_ERROR,
  GET_HAZARDS,
} from "../../constants";
import axios from "../../../../services/api";

function* getHazards(data) {
  const params = new URLSearchParams();

  if (data.siteId) {
    params.append("site_id", data.siteId);
  }

  try {
    const response = yield call(axios.get, `/hazards/`, {
      params,
    });
    if (response.data.error) {
      yield put({
        type: GET_HAZARDS_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_HAZARDS_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: GET_HAZARDS_ERROR,
      data: error,
    });
  }
}

export default function* getHazardsSaga() {
  yield takeLatest(GET_HAZARDS, getHazards);
}
